











import { Vue, Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { StoreState } from '../../../store';

@Component({
    mounted: function() {
        this.$store.commit('SET_TIMEZONE', {
            timezone: this.$data.timezones[0]
        });
    },
    computed: {
        ...mapState({
            timezone: (state: StoreState) => state.reports.filters.timezone
        })
    }
})
export default class TimezoneFilter extends Vue {
    data() {
        return {
            timezones: [
                {
                    abbrev: 'ET',
                    tz: 'America/New_York'
                }, {
                    abbrev: 'CT',
                    tz: 'America/Chicago'
                }, {
                    abbrev: 'MT',
                    tz: 'America/Denver'
                }, {
                    abbrev: 'PT',
                    tz: 'America/Los_Angeles'
                }
            ],
        }
    }

    timezoneChanged($event: any) {
        const tz = this.$data.timezones.filter((t: any) => t.abbrev === $event.target.value)[0];
        this.$store.commit('SET_TIMEZONE', {
            timezone: tz
        });
    }
}
